import api from "@/api/api-v2-config";

export async function getMarketingCampaign() {    
    return await api.get("marketings/getmarketingcampaignlist?PageNumber=1&PageSize=10000");
}

export async function getMarketingCampaignById(id) {    
    return await api.get("marketings/getcampaignbyid?id=" + id);
}


export async function postMarketingCampaign(data) {
    return await api.post("marketings/createmarketingcampaign", data);
}

export async function putMarketingCampaign(data) {
    return await api.put("marketings/updatemarketingcampaign", data);
}

export async function deleteMarketingCampaign(id) {
    return await api.delete("marketings/deletemarketingcampaign?id=" + id);
}